export default __webpack_public_path__ + "search-examples-mapbox-mapview-1200-fbb41b38b83da4879def3d02e13882b4.webp";